<template>
    <div v-click-outside="hideAutoCompleteList">
        <input type="text" :placeholder="placeholder" @click="resolveGeoLocations" @keydown="keydown" :name="name" v-model="locationSearchInput" autocomplete="off" aria-autocomplete="list" />
        
        <div class="autocomplete-locations" v-if="listVisible">
            <ul>
                <li class="autocomplete-locations__item"
                    v-for="(location, index) in geocodingLocations" 
                    :class="{'autocomplete-locations__item--active': activeItem === index}"
                >
                    <button @click.prevent="setInputValueTo(location.description)" >{{ location.description }}</button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import GmapsLoader from '@/helpers/gmapsloader/';

    export default {
    	props: {
            placeholder: {
                default: 'Zoeken op plaatsnaam'
            },
            value: {
                default: ''
            },
            name: {
                default: ''
            }
        },
        directives: {
            'click-outside': {
                bind(el, binding, vnode) {
                    el.event = function (event) {
                        if (!(el == event.target || el.contains(event.target))) {
                         vnode.context[binding.expression](event);
                        }
                    };

                    document.body.addEventListener('click', el.event)
                },
                unbind(el) {
                    document.body.removeEventListener('click', el.event)
                }
            }
        },
    	data: function(){
    		return {
    			locationSearchInput: this.value,
                geocodingLocations: [],
                geoTimeout: null,
                currentResolvedString: '',
                activeItem: null,
                listVisible: false,
                gmapsReady: false
    		}
    	},
        watch: {
            locationSearchInput() {
                this.$emit('change', this.locationSearchInput);
            },
            value() {
                this.locationSearchInput = this.value;
            }
        },
        mounted() {
            GmapsLoader.load(() => {
                this.gmapsReady = true;
            });
        },
        methods: {
            keydown(e) {
                let selectedLocation = null;

                if(this.activeItem !== null) {
                    selectedLocation = this.geocodingLocations[this.activeItem];
                }
                // arrow up
                if(e.keyCode == 40) {
                    if(this.activeItem === null){
                        this.activeItem = 0;
                    }
                    else {
                        this.activeItem++;
                    }

                    if(this.activeItem >= this.geocodingLocations.length) {
                        this.activeItem = 0;
                    }

                    selectedLocation = this.geocodingLocations[this.activeItem];
                    if(selectedLocation && selectedLocation.description) {
                        this.setSoftInputValueTo(selectedLocation.description);
                    }
                }
                // arrow down
                else if(e.keyCode == 38) {
                    this.activeItem--;

                    if(this.activeItem < 0) {
                        this.activeItem = this.geocodingLocations.length-1;
                    }

                    selectedLocation = this.geocodingLocations[this.activeItem];
                    if(selectedLocation && selectedLocation.description) {
                        this.setSoftInputValueTo(selectedLocation.description);
                    }
                }
                // enter
                else if(e.keyCode == 13) {
                    e.preventDefault();

                    if(selectedLocation && selectedLocation.description) {
                        this.setInputValueTo(selectedLocation.description);
                    }
                    else {
                        this.setInputValueTo(this.locationSearchInput);   
                    }

                    this.hideAutoCompleteList();

                    this.unfocusField();
                }
                // esc
                else if(e.keyCode == 27) {
                    this.hideAutoCompleteList();
                }
                else {
                    this.activeItem = null;

                    if(this.locationSearchInput != this.currentResolvedString) {
                        this.geocodingLocations = [];
                    }


                    clearTimeout(this.geoTimeout);

                    this.geoTimeout = setTimeout(() => {
                        this.resolveGeoLocations();
                    }, 200);
                }                
            },
            resolveGeoLocations() {
                if(!this.gmapsReady) {
                    return;
                }
                
                this.listVisible = true;

                this.currentResolvedString = this.locationSearchInput;

                if(!this.locationSearchInput) {
                    this.geocodingLocations = [];
                }
                else {
                    const AutocompleteService = new google.maps.places.AutocompleteService();
                    AutocompleteService.getPlacePredictions({ input: this.locationSearchInput,  types: ['geocode'], componentRestrictions: {country: 'nl'} }, (results) => {
                        this.geocodingLocations = results;
                    });
                }
            },
            setInputValueTo(value) {
                this.locationSearchInput = this.currentResolvedString = value;
                // remove all resolved locations
                this.geocodingLocations = '';

                this.$emit('change', this.locationSearchInput);
                this.$emit('submit', this.locationSearchInput);
            },
            setSoftInputValueTo(value) {
                this.locationSearchInput = this.currentResolvedString = value;

                this.$emit('change', this.locationSearchInput);
                this.$emit('submit', this.locationSearchInput);
            },
            hideAutoCompleteList() {
                clearTimeout(this.geoTimeout);
                this.listVisible = false;
            },
            showAutoCompleteList() {
                if(this.locationSearchInput && this.geocodingLocations.length > 0) {
                    this.listVisible = true;
                }
            },
            unfocusField() {
                const tmpInputField = document.createElement("input");
                tmpInputField.classList.add('unfocusfield');
                document.body.appendChild(tmpInputField);
                tmpInputField.focus();
                document.body.removeChild(tmpInputField);
            }
        },
        destroyed() {
            clearTimeout(this.geoTimeout);
        }
    }
</script>